import React from "react";
import PropTypes from "prop-types";
import FormMaxError from "../../errors/FormMaxError";
import FormInvalidError from "../../errors/FormInvalidError";
import FormRequiredError from "../../errors/FormRequiredError";

class FormZipError extends React.Component{
    render() {
        switch (this.props.error) {
            case "address.form.zip.max" :
                return <FormMaxError field_name={"CMS.Profile." + this.props.error.slice(0, -4)} max={50} />;
            case "address.form.zip.invalid":
                return <FormInvalidError field_name={"CMS.Profile." + this.props.error.slice(0, -8)}/>;
            default:
                return <FormRequiredError field_name={"CMS.Profile." + this.props.error}/>;
        }
    }
}

FormZipError.propTypes = {
    error: PropTypes.string.isRequired,
};
export default FormZipError;